import { useAuthStore } from "@/lib/swr";
import PrdTable from "./prd-table";

// My PRDs tab of /prds: PRDs and bugs I own OR am a member of (assigneeId —
// both mean I have to act before the row can clear, owner 2026-09-08; one
// pool since issue unification, bug rows carry the red chip), as the stage-
// bucketed work queue. Following is a different behaviour (subscribe only)
// and lives on /users/:id. Everything waiting on an action right now is the
// Inbox at "/".
const MyPrds = () => {
  const userId = useAuthStore((s) => s.auth?.user?.id as string | undefined);
  if (!userId) return <PrdTable />;
  return (
    <PrdTable
      params={{ assigneeId: userId }}
      workQueue
      breadcrumb={[{ label: "My PRDs", to: "/prds" }]}
    />
  );
};

export default MyPrds;
